import { createFileRoute } from "@tanstack/react-router";
import { MslAvailabilityPage } from "@/features/contracts/msl-availability-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/msl-dostepnosc/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.msl-dostepnosc",
			location.pathname,
		);
	},
	component: MslAvailabilityPage,
});
